module.exports = __webpack_public_path__ + "img/loma_thumb.ed7b1f22.jpg";